import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../../../shared/services/user.service';

@Component({
  selector: 'app-result',
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.scss'],
})
export class ResultComponent implements OnInit {
  seconds;
  donationAmount;
  donationString;
  inTime = false;

  showSocial = true;
  showDonate = true;
  whatsApp: string;
  callSend = false;

  selectedBank: string;
  data: Array<{ id: string; name: string }> = [
    { id: undefined, name: 'Selecteer een bank' },
    { id: 'abnamro', name: 'ABN AMRO' },
    { id: 'asnbank', name: 'ASN BANK' },
    { id: 'ing', name: 'ING' },
    { id: 'knab', name: 'KNAB' },
    { id: 'rabobank', name: 'RABOBANK' },
    { id: 'snsregiobank', name: 'REGIOBANK' },
    { id: 'snsbank', name: 'SNS BANK' },
    { id: 'triodosbank', name: 'TRIODOS BANK' },
    { id: 'vanlanschot', name: 'VAN LANSCHOT' },
    { id: 'revolut', name: 'Revolut' },
    { id: 'bunq', name: 'Bunq' },
    { id: 'nationale-nederlanden', name: 'Nationale-Nederlanden' },
    { id: 'n26', name: 'N26' },
    { id: 'yoursafe', name: 'Yoursafe' },
  ];
  shareText = '';
  // Tikki
  linkTikki = '#';
  donateURL = '';
  constructor(
    private userService: UserService,
    private toastr: ToastrService,
    private meta: Meta
  ) {}

  ngOnInit() {
    document.body.classList.add('intro');
    document.body.classList.remove('game');
    this.toastr.clear();
    this.seconds = this.userService.playTime || 61;
    this.donationAmount = Math.min(this.seconds * 10, 600);
    this.donationString = `€ ${(this.donationAmount / 100)
      .toFixed(2)
      .replace('.', ',')}`;
    this.inTime = this.userService.isInTime();

    const {
      firstName,
      lastName,
      email,
      zipCode,
      houseNumber,
      houseNumberAddition,
      streetName,
      city,
      middleName,
    } = this.userService.user;

    const url = new URL('https://bartimeusfonds.nl/oneclick');
    url.searchParams.append('amount', (this.donationAmount / 100).toFixed(2));
    url.searchParams.append('form_id', '14');
    url.searchParams.append('firstname', firstName);
    if (middleName) {
      url.searchParams.append('middlename', middleName);
    }
    url.searchParams.append('lastname', lastName);
    url.searchParams.append('email', email);
    url.searchParams.append('agreement', 'ja-akkoord-privacy');
    url.searchParams.append('street', streetName);
    url.searchParams.append('number', houseNumber);
    url.searchParams.append('zipcode', zipCode);
    url.searchParams.append('city', city);
    if (houseNumberAddition) {
      url.searchParams.append('addon', houseNumberAddition);
    }

    this.donateURL = url.toString();

    this.donateURL += `&bank=`;

    if (!this.inTime) {
      this.setFailedMeta();
    } else {
      this.setSuccesMeta();
    }
    this.whatsApp =
      'https://api.whatsapp.com/send?text=' +
      encodeURIComponent(
        this.shareText +
          'https://bestellenin60tellen.nl/?utm_source=socialmedia&utm_medium=Whatsapp&utm_campaign=bi60t_share'
      );
  }

  setFailedMeta(): void {
    this.shareText =
      'Ik heb meegedaan aan Bestellen in 60 tellen met een visuele beperking en het is me helaas niet gelukt. Lukt het jou wel?';
  }

  setSuccesMeta(): void {
    this.shareText = `Ik heb meegedaan aan Bestellen in 60 tellen met een visuele beperking en ik had nog ${
      60 - this.seconds
    } seconden over! Ga jij ook de uitdaging aan? `;
  }

  clickTwitter(): void {
    const url = `https://twitter.com/intent/tweet?url=https://bestellenin60tellen.nl/?utm_source=socialmedia%26utm_medium=Twitter%26utm_campaign=bi60t_share&text=${this.shareText}`;
    window.open(url, undefined, 'width = 600, height = 300');
  }

  clickFacebook(): void {
    window.open(
      'http://www.facebook.com/sharer.php?u=https://bestellenin60tellen.nl/?utm_source=socialmedia%26utm_medium=facebook%26utm_campaign=bi60t_share',
      undefined,
      'width = 600, height = 300'
    );
  }

  clickDonate(e: Event): void {
    if (this.callSend || !this.selectedBank) {
      e.preventDefault();
    } else {
      this.callSend = true;
    }
    return;
  }
}
